import './index.css';
import '@h2oai/ui-kit/lib/assets/css/include-inter.css';
import '@h2oai/ui-kit/lib/assets/css/variables.css';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App/App';
import { bootstrapDiscovery, ErrorScreen } from './bootstrap';
import { AppProviders } from './components/AppProviders/AppProviders';
import { applyCustomTheme } from './utils/theme';

// TODO: Add React.StrictMode when fluentui team will fix all the errors or submit PRs and do it for them.
// https://github.com/microsoft/fluentui/issues/4613

/**
 * This enhances the JSX namespace with a <search> element, which is missing in the current version of @types/react
 * but is a browser baseline since 2023
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/search
 */
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      search: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
    }
  }
}

/**
 * Renders the error screen when bootstrap fails
 */
const renderError = (error: Error | string | unknown): void => {
  ReactDOM.render(<ErrorScreen error={error} />, document.getElementById('root'));
};

/**
 * Bootstraps and renders the application
 */
const loadApp = async (): Promise<void> => {
  try {
    const { discovery, auth } = await bootstrapDiscovery();

    applyCustomTheme();

    ReactDOM.render(
      <AppProviders discovery={discovery} auth={auth}>
        <App />
      </AppProviders>,
      document.getElementById('root')
    );
  } catch (error) {
    renderError(error);
  }
};

loadApp();
